<template>
    <jet-action-section>
        <template #title>
            Show Implied Probability
        </template>
        <template #description>
            Show implied probability in meetings accordian instead of fraction representation.
        </template>
        <template #content>
            <div class="inflex items-center">
                <jet-button v-if="getStoredProbabilityPref() === true && restartClicked === false" type="button" @click="setImpliedProbabilityPref(!getStoredProbabilityPref()); restartClicked=true">
                    Disable Implied Probability
                </jet-button>
                <jet-button v-if="getStoredProbabilityPref() === false && restartClicked === false" type="button" @click="setImpliedProbabilityPref(!getStoredProbabilityPref()); restartClicked=true">
                    Enable Implied Probability
                </jet-button>
                <div v-else-if="restartClicked === true">
                    <p class="text-sm text-gray-600 transition duration-500 ease-in-out dark:text-white">Preference changed.</p>
                </div>
            </div>
        </template>
    </jet-action-section>
</template>
<script>
import JetActionSection from '@/Jetstream/ActionSection.vue'
import JetButton from '@/Jetstream/Button.vue'
import JetConfirmsPassword from '@/Jetstream/ConfirmsPassword.vue'
import JetDangerButton from '@/Jetstream/DangerButton.vue'
import JetSecondaryButton from '@/Jetstream/SecondaryButton.vue'

export default {
    components: {
        JetActionSection,
        JetButton,
        JetConfirmsPassword,
        JetDangerButton,
        JetSecondaryButton,
    },

    data() {
        return {

        }
    },

    methods: {
        // Get stored implied probability preference from local user storage 
        getStoredProbabilityPref() {
            let storedProbabilityPref = localStorage.getItem('showImpliedProbability')

            if (storedProbabilityPref) {
                return (localStorage.getItem('showImpliedProbability') === 'true')
            }

            return false
        },

        setImpliedProbabilityPref(value){
            // Store value of previously selected countryCode in cookies to continue on page later
            localStorage.setItem('showImpliedProbability', value)
        },
        

    },

    props: ['user'],

    props: {
        user: {
            type: Object,
        },

        restartClicked: {
            type : Boolean,
            default : false,
        },
    },

    setup(props) {

    }
}

</script>
